import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_item_review_hdr_RowClass} from '../../../dbschema';

export class ReviewContainerModel extends BaseContainerModel {
  bl_fi_item_review_hdr: bl_fi_item_review_hdr_RowClass = new bl_fi_item_review_hdr_RowClass();
}
